import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';
import {TokenInterceptor} from './shared/token-interceptor.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule, MatCardSubtitle, MatCardTitle} from '@angular/material/card';
import {HeaderComponent} from './header/header.component';
import {MatIconModule} from '@angular/material/icon';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import {LeftMenuComponent} from './left-menu/left-menu.component';
import {MatListModule} from '@angular/material/list';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {LoginComponent} from './login/login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormMessagesComponent} from './form-messages/form-messages.component';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {DeckExplorerModule} from './deck-explorer/deck-explorer.module';
import {DesignRecommenderModule} from './design-recommender/design-recommender.module';
import {AuthConfigModule} from './auth-config.module';
import {AuthInterceptor} from './shared/auth-interceptor';
import {MatTooltipModule} from '@angular/material/tooltip';
import {HelpMenuComponent} from './help-menu/help-menu.component';
import {OverlayModule} from '@angular/cdk/overlay';
import {MatTabsModule} from '@angular/material/tabs';
import {GraphEditorModule} from './graph-editor/graph-editor.module';
import {MatMenuModule} from '@angular/material/menu';
import {ExtendedOptionsComponent} from './extended-options/extended-options.component';
import {ImageDownloadDialogComponent} from './image-download-dialog/image-download-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {DashboardComponent} from './dashboard/dashboard.component';
import {CardVisualizationComponent} from './card-visualization/card-visualization.component';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {LOCALE_ID} from '@angular/core';
import {MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {DesignGroupComponent} from './dashboard/design-group/design-group.component';
import {MatButtonToggle, MatButtonToggleGroup} from '@angular/material/button-toggle';
import {AutoFocusDirective} from './shared/auto-focus.directive';
import {ShareDialogComponent} from './dashboard/share-dialog/share-dialog.component';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {InvitationDialogComponent} from './dashboard/invitation-dialog/invitation-dialog.component';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef, MatHeaderRow,
  MatHeaderRowDef, MatRow, MatRowDef,
  MatTable
} from '@angular/material/table';
import {MatBadge} from '@angular/material/badge';
import {MatPaginator} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    LeftMenuComponent,
    LoginComponent,
    FormMessagesComponent,
    HelpMenuComponent,
    ExtendedOptionsComponent,
    ImageDownloadDialogComponent,
    DashboardComponent,
    CardVisualizationComponent,
    DesignGroupComponent,
    ShareDialogComponent,
    InvitationDialogComponent,
  ],
  exports: [
    CardVisualizationComponent
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatCardModule,
    MatCardTitle,
    MatCardSubtitle,
    MatIconModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    DeckExplorerModule,
    DesignRecommenderModule,
    AuthConfigModule,
    MatTooltipModule,
    OverlayModule,
    MatTabsModule,
    GraphEditorModule,
    MatMenuModule,
    MatDialogModule,
    MatSlideToggleModule,
    FormsModule,
    MatProgressBarModule,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatButtonToggleGroup,
    MatButtonToggle,
    AutoFocusDirective,
    MatRadioGroup,
    MatRadioButton,
    MatSortModule,
    MatTable,
    MatHeaderCell,
    MatCell,
    MatColumnDef,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRowDef,
    MatRowDef,
    MatHeaderRow,
    MatRow, MatBadge, MatPaginator], providers: [
    {provide: LOCALE_ID, useValue: 'de'},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
}
